import React from 'react';
import { Input, InputNumber } from 'antd';
import Config from '../../Config';

/* eslint-disable react/display-name */

export default async function getServicesTableColumns() {
  return [
    {
      title: 'Service Name',
      dataIndex: 'name',
      editable: true,
      getInput: () => <Input />,
      required: true
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      editable: true,
      getInput: () => <InputNumber
        min={Config.PRIORITY_MIN_VAL}
        max={Config.PRIORITY_MAX_VAL}
      />,
      required: true
    }
  ];
}